import React from "react";
import { CaretDown, Trash } from "@phosphor-icons/react";

// One card open at a time; header shows the item's own summary line.
export const CollapsibleCard = ({ title, open, onToggle, onRemove, nudge, testid, children }) => (
  <div className="card !p-0 overflow-hidden" data-testid={testid}>
    <div className="flex items-center gap-2 px-5 py-4">
      <button
        type="button"
        onClick={onToggle}
        className="flex-1 flex items-center gap-3 text-left min-w-0"
        data-testid={`${testid}-toggle`}
        aria-expanded={open}
      >
        <CaretDown size={16} weight="bold" className={`shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`} />
        <span className="font-heading uppercase tracking-wide break-words sm:truncate min-w-0" data-testid={`${testid}-header`}>
          {title}
        </span>
      </button>
      <button type="button" className="btn-secondary !px-3 !py-2" onClick={onRemove} data-testid={`${testid}-remove`} aria-label="Delete">
        <Trash size={16} />
      </button>
    </div>
    {open && (
      <div className="px-5 pb-5 border-t border-black/10 pt-4">
        {nudge && (
          <p className="text-xs text-red-700 font-semibold mb-3" data-testid={`${testid}-nudge`}>
            {typeof nudge === "string" ? nudge : "Add a name and amount first."}
          </p>
        )}
        {children}
      </div>
    )}
  </div>
);

export default CollapsibleCard;
